import { useEffect, useRef } from "react";
import Lenis from "lenis";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Intro from "@/components/landing/Intro";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import Reviews from "@/components/landing/Reviews";
import TowRequestForm from "@/components/landing/TowRequestForm";
import JunkCarForm from "@/components/landing/JunkCarForm";
import LocationSection from "@/components/landing/LocationSection";
import Footer from "@/components/landing/Footer";
import StickyCallBar from "@/components/landing/StickyCallBar";

export default function Landing() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="landing-page" className="relative bg-ink text-slate-100 overflow-x-clip">
      <div className="noise-overlay fixed inset-0 z-[60]" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Intro />
        <Manifesto />
        <Services />
        <Reviews />
        <TowRequestForm />
        <JunkCarForm />
        <LocationSection />
      </main>
      <Footer />
      <StickyCallBar />
    </div>
  );
}
